import { getLocationService } from '@guiker/base-entity'
import { yup } from '@guiker/yup-util'

const locationService = getLocationService()

export const byCity = yup.object({
  cityId: yup.mixed().oneOf(locationService.allCitySlugs).required(),
})
